import { useTheme } from '@mui/material';

export interface ContentLinkedinPlayerProps {
  videoUrl: string;
  contentId: number;
  memberId: string;
  contentTitle?: string;
  contentCreatorName?: string | null
}

export default function ContentLinkedinPlayer(
  {
    videoUrl, contentId, memberId, contentTitle, contentCreatorName,
  }: ContentLinkedinPlayerProps,
) {
  const theme = useTheme();
  const opts = {
    height: '100%',
    width: '100%',
  };

  return (
    <iframe
      src={videoUrl}
      height={opts.height}
      width={opts.width}
      frameBorder="0"
      allowFullScreen
      style={{ display: 'block', borderRadius: theme.spacing(2) }}
      title={contentTitle}>
    </iframe>
  );
}
